import { motion } from 'framer-motion'
import React, { useState } from 'react'
import styled from 'styled-components'

import { TestingDataType } from '..'
import camerapngImg from '../images/camera.png'
import errorcameraImg from '../images/error-camera.png'
import errormikeImg from '../images/error-mike.png'
import errorvoiceImg from '../images/error-voice.png'
import errorwifiImg from '../images/error-wifi.png'
import linkImg from '../images/link.png'
import mikepngImg from '../images/mike.png'
import nolinkImg from '../images/nolink.png'
import notcameraImg from '../images/not-camera.png'
import notmikeImg from '../images/not-mike.png'
import notvoiceImg from '../images/not-voice.png'
import notwifiImg from '../images/not-wifi.png'
import successcameraImg from '../images/success-camera.png'
import successmikeImg from '../images/success-mike.png'
import successvoiceImg from '../images/success-voice.png'
import successwifiImg from '../images/success-wifi.png'
import voicepngImg from '../images/voice.png'
import wifipngImg from '../images/wifi.png'

interface IProps {
  testingData: TestingDataType
  stepActive: number
}

export default ({ testingData, stepActive }: IProps) => {
  const returnClassName = (stepNum: number) => {
    let type: 'voice' | 'mike' | 'camera' | 'wifi' | '' = ''
    switch (stepNum) {
      case 1:
        type = 'voice'
        break
      case 2:
        type = 'mike'
        break
      case 3:
        type = 'camera'
        break
      case 4:
        type = 'wifi'
        break
      default:
        break
    }
    if (stepActive === stepNum) {
      return `box-${type}`
    }
    if (stepActive > stepNum && type) {
      return testingData[type] ? `box-success-${type}` : `box-error-${type}`
    }
    return `box-not-${type}`
  }

  return (
    <Container>
      <div className={` step-box ${returnClassName(1)}`} />
      <div className={`${stepActive >= 2 ? 'step-link' : 'step-nolink'}`} />
      <div className={`step-box ${returnClassName(2)}`} />
      <div className={`${stepActive >= 3 ? 'step-link' : 'step-nolink'}`} />
      <div className={`step-box ${returnClassName(3)}`} />
      <div className={`${stepActive >= 4 ? 'step-link' : 'step-nolink'}`} />
      <div className={`step-box ${returnClassName(4)}`} />
    </Container>
  )
}

const Container = styled(motion.div)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 50px;
  margin-bottom: 35px;
  .step-nolink {
    width: 60px;
    height: 12px;
    background-image: url('${nolinkImg}');
    background-position: 0 0;
    background-size: 100% 100%;
  }
  .step-link {
    width: 60px;
    height: 12px;
    background-image: url('${linkImg}');
    background-position: 0 0;
    background-size: 100% 100%;
  }
  .step-box {
    // width: 7.29vw;
    // height: 7.29vw;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
    background-position: 0 0;
    background-size: 100% 100%;
  }
  .box-not-voice {
    background-image: url('${notvoiceImg}');
  }
  .box-voice {
    background-image: url('${voicepngImg}');
  }
  .box-success-voice {
    background-image: url('${successvoiceImg}');
  }
  .box-error-voice {
    background-image: url('${errorvoiceImg}');
  }
  .box-not-mike {
    background-image: url('${notmikeImg}');
  }
  .box-mike {
    background-image: url('${mikepngImg}');
  }
  .box-success-mike {
    background-image: url('${successmikeImg}');
  }
  .box-error-mike {
    background-image: url('${errormikeImg}');
  }
  .box-not-camera {
    background-image: url('${notcameraImg}');
  }
  .box-camera {
    background-image: url('${camerapngImg}');
  }
  .box-success-camera {
    background-image: url('${successcameraImg}');
  }
  .box-error-camera {
    background-image: url('${errorcameraImg}');
  }
  .box-not-wifi {
    background-image: url('${notwifiImg}');
  }
  .box-wifi {
    background-image: url('${wifipngImg}');
  }
  .box-success-wifi {
    background-image: url('${successwifiImg}');
  }
  .box-error-wifi {
    background-image: url('${errorwifiImg}');
  }
`
